import React, { useContext } from "react";
import { AppContext } from "../context/Context";

export default function HeroSection() {
  const { hero, loading } = useContext(AppContext);

  console.log("Hero:", hero);
if (loading || !hero) {
  return (
    <div className="logo-bar text-center py-3">
      Loading...
    </div>
  );
}

  return (
    <section
      className="hero"
      style={{
        background:
          "url('/background-img.jpeg') center / cover no-repeat"
      }}
    >
      <div className="container">
        <div className="hero-content">

          <div className="hero-badge">
            <span></span>
            {hero.title}
          </div>

          <h1 className="hero-title">
            {hero.description1}
            <br />
            {hero.description2}
          </h1>

          <div className="hero-stats">
            <div className="hero-stat">
              <h3>₹{Number(hero.csr_deployed).toLocaleString("en-IN")}</h3>
              <p>CSR Deployed</p>
            </div>

            <div className="hero-stat">
              <h3>{Number(hero.active_project).toLocaleString()}</h3>
              <p>Active Projects</p>
            </div>

            <div className="hero-stat">
              <h3>{Number(hero.benificiaries).toLocaleString()}</h3>
              <p>Beneficiaries</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
